export const DEFAULT_TIMEFRAME = 'this_14_days';
export const RELATIVE_TAB = 'relative';
export const ABSOLUTE_TAB = 'absolute';
